// removed by extract-text-webpack-plugin
module.exports = {"need-offer-by-category-container":"need-offer-by-category-container","need-offer-by-category-wrap":"need-offer-by-category-wrap","need-offer-by-category-title":"need-offer-by-category-title","need-offer-by-category-title-wrap":"need-offer-by-category-title-wrap","view-more-link":"view-more-link","need-offer-by-category":"need-offer-by-category"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_NeedOffersByCategoryContainer.scss
// module id = ./components/home/sub-view/_NeedOffersByCategoryContainer.scss
// module chunks = 0